import type { RouteObject } from "react-router-dom";
import { MorePage } from "./MorePage";

export const routes: RouteObject[] = [{ path: "more", element: <MorePage /> }];
